export default function getResource(label, vars = []) {
    const resources = {
        automaticUpdate: 'Choisir une date actualisera automatiquement les magasins et les plages horaires affichés.',
        chooseDate: 'Sélectionner une date',
        seeMoreDates: 'Voir plus de dates'
    };

    return resources[label];
}
